import "../css/AdmissionPageComponent.scss"
import React from 'react'
import BannerComponent from "./BannerComponent"
import AdmissionBannerImage from '../assets/WhatsApp Image 2024-09-23 at 4.44.24 PM 1.png'
import StepImage from '../assets/Frame 1000003446.png'
import StepImage2 from '../assets/Frame 1000003471.png'
import StepImage3 from '../assets/Frame 1000003445.png'
import StepImage4 from '../assets/Frame 1000003469.png'


const AdmissionPageComponent = () => {
  return (
    <div className="admission-section"> 
         <BannerComponent
        title='Admission 2026/2027'
        image={AdmissionBannerImage}
        description='Nursery and Primary'
        buttonInformation={
          <>
            <a href="/apply-for-admission">Enroll Now</a>
          </>
        }
      />

      <div className="admission-steps-section page-width">
        <div className="admission-header">
            <header className="main-header">Steps To Apply For Admission</header>
            <p className="instruction">Follow these easy steps to start your journey with us and secure your place at our school.</p>
        </div>

        <div className="steps-container">
            <div className="step">
                <div className="step-header-content">
                    <img src={StepImage} className = 'step-image' alt="#" />
                    <header>Enquiry</header>
                </div>

                <p>
                    Submit a quick enquiry with your child's details and we'll reach out to you.
                </p>
            </div>

            <div className="step">
                <div className="step-header-content">
                    <img src={StepImage2} className = 'step-image' alt="#" />
                    <header>Assessment</header>
                </div>

                <p>
                    We schedule a simple assessment to understand your child's needs and abilities.
                </p>
            </div>

            <div className="step">
                <div className="step-header-content">
                    <img src={StepImage3} className = 'step-image' alt="#" />
                    <header>Admission Offer</header>
                </div>

                <p>
                    On success, we send an admission letter with fees and enrollment details.
                </p>
            </div>

            <div className="step">
                <div className="step-header-content">
                    <img src={StepImage4} className = 'step-image' alt="#" />
                    <header>Welcome</header>
                </div>

                <p>
                    Complete enrollment and join us for orientation before resumption.
                </p>
            </div>

        </div>
        <div className="application-button-container">
            <button className="application-button"><a href="/apply-for-admission">Apply for Admission</a></button>
        </div>
      </div>

      <div className="admission-info-section page-width">
        <div className="info-card">
            <header>School Fees</header>
            <p>Detailed fee schedules for Early Years and Primary are shared on request after your initial enquiry. We offer sibling discounts and flexible payment plans.</p>
        </div>

        <div className="info-card">
            <header>Key Dates</header>
            <ul className="key-dates-list">
                <li><span className="key-dates-label">Open Day:</span> Every 2nd Saturday of the month, 10am</li>
                <li><span className="key-dates-label">Assessments:</span> Rolling - monthly cohorts</li>
                <li><span className="key-dates-label">Resumption:</span> Second week of September</li>
            </ul>
        </div>
      </div>
    </div>
  )
}

export default AdmissionPageComponent
